import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider, AnimatedPage } from '@theonefamily/ui';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AppLayout } from '@/layouts/AppLayout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import VehicleListPage from '@/pages/VehicleListPage';
import VehicleDetailPage from '@/pages/VehicleDetailPage';
import GPSTrackingPage from '@/pages/GPSTrackingPage';
import MaintenancePage from '@/pages/MaintenancePage';
import InventoryPage from '@/pages/InventoryPage';
import OrdersPage from '@/pages/OrdersPage';
import InspectionsPage from '@/pages/InspectionsPage';
import FuelPage from '@/pages/FuelPage';
import TripsPage from '@/pages/TripsPage';
import DriversPage from '@/pages/DriversPage';
import ReportsPage from '@/pages/ReportsPage';
import AdminPage from '@/pages/AdminPage';
import DispatchPage from '@/pages/DispatchPage';
import VisitLogPage from '@/pages/VisitLogPage';
import CommandCenterPage from '@/pages/CommandCenterPage';
import CostAllocationPage from '@/pages/CostAllocationPage';
import PredictivePage from '@/pages/PredictivePage';
import SafetyPage from '@/pages/SafetyPage';
import WorkOrdersPage from '@/pages/WorkOrdersPage';
import CompliancePage from '@/pages/CompliancePage';
import TcoPage from '@/pages/TcoPage';
import FuelAnalyticsPage from '@/pages/FuelAnalyticsPage';
import AgentDispatchPage from '@/pages/AgentDispatchPage';
import CmdbSyncPage from '@/pages/CmdbSyncPage';
import RouteReplayPage from '@/pages/RouteReplayPage';
import BenchmarkPage from '@/pages/BenchmarkPage';
import PartsForecastPage from '@/pages/PartsForecastPage';
import FleetAdvisorPage from '@/pages/FleetAdvisorPage';
import QbrReportsPage from '@/pages/QbrReportsPage';
import HosPage from '@/pages/HosPage';
import IotDevicesPage from '@/pages/IotDevicesPage';
import InspectionTemplatesPage from '@/pages/InspectionTemplatesPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  return (
    <ErrorBoundary>
    <ToastProvider>
      <AnimatedPage>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
      <Route element={<AppLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/vehicles" element={<VehicleListPage />} />
        <Route path="/vehicles/:vehicleId" element={<VehicleDetailPage />} />
        <Route path="/gps" element={<GPSTrackingPage />} />
        <Route path="/dispatch" element={<DispatchPage />} />
        <Route path="/command-center" element={<CommandCenterPage />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/predictive" element={<PredictivePage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/inspections" element={<InspectionsPage />} />
        <Route path="/fuel" element={<FuelPage />} />
        <Route path="/trips" element={<TripsPage />} />
        <Route path="/visit-logs" element={<VisitLogPage />} />
        <Route path="/cost-allocation" element={<CostAllocationPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/work-orders" element={<WorkOrdersPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/tco" element={<TcoPage />} />
        <Route path="/fuel-analytics" element={<FuelAnalyticsPage />} />
        <Route path="/agent-dispatch" element={<AgentDispatchPage />} />
        <Route path="/cmdb-sync" element={<CmdbSyncPage />} />
        <Route path="/route-replay" element={<RouteReplayPage />} />
        <Route path="/benchmarks" element={<BenchmarkPage />} />
        <Route path="/parts-forecast" element={<PartsForecastPage />} />
        <Route path="/fleet-advisor" element={<FleetAdvisorPage />} />
        <Route path="/qbr-reports" element={<QbrReportsPage />} />
        <Route path="/hos" element={<HosPage />} />
        <Route path="/iot-devices" element={<IotDevicesPage />} />
        <Route path="/inspection-templates" element={<InspectionTemplatesPage />} />
        <Route path="/drivers" element={<DriversPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
        </Routes>
      </AnimatedPage>
    </ToastProvider>
    </ErrorBoundary>
  );
}
